import { render, staticRenderFns } from "./FeedBackSender.vue?vue&type=template&id=a9c12858&scoped=true&"
import script from "./FeedBackSender.vue?vue&type=script&lang=js&"
export * from "./FeedBackSender.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackSender.vue?vue&type=style&index=0&id=a9c12858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c12858",
  null
  
)

export default component.exports